import React from 'react';
import ToolbarGroup from './ToolbarGroup';
import tools from '../../tools';
import { type Editor } from 'slate';
import BlockUtils from '../../plugins/Blocks/BlockUtils';
import classnames from 'classnames';

const blockTools = [
  tools.ToolToggleParagraph,
  tools.ToolToggleHeading1,
  tools.ToolToggleHeading2,
  tools.ToolToggleHeading3,
  tools.ToolToggleHeading4,
  tools.ToolToggleHeading5,
  tools.ToolToggleHeading6,
  tools.ToolToggleCode,
  tools.ToolToggleQuote,
];

const toolToIcon = blockTools.reduce((acc, tool) => {
  acc[tool.toolName] = tool.iconClass;
  return acc;
}, {});

const ToolbarBlockMenu = ({ compact }: { compact?: boolean } = {}) =>
  ToolbarGroup({
    menu: {
      icon: 'fa-regular fa-paragraph',
      name: 'Paragraph',
      menuStyle: 'component',
      triggerComponent: ({ editor }: { editor: Editor }) => {
        const blockTitle = BlockUtils.currentBlockTitle(editor);
        if (compact) {
          return (
            <i
              className={classnames(
                'fa-fw',
                toolToIcon[blockTitle] || 'fa-regular fa-paragraph'
              )}
            />
          );
        }
        return <span>{blockTitle}</span>;
      },
      tools: blockTools,
    },
  });

export default ToolbarBlockMenu;
